/**
 * Pinecone injects route HTML without reliably executing inline <script> tags.
 * Wire the forgot-password form after each navigation.
 */
function fmtRetry(ms) {
  const n = Number(ms);
  if (!Number.isFinite(n) || n <= 0) return 'Try again later.';
  const sec = Math.ceil(n / 1000);
  if (sec < 120) return `Try again in about ${sec} seconds.`;
  const min = Math.ceil(sec / 60);
  return `Try again in about ${min} minute${min === 1 ? '' : 's'}.`;
}

function bindAdminForgotFormOnce() {
  const form = document.getElementById('adminForgotForm');
  if (!form || form.dataset.pdlBound === '1') return;
  form.dataset.pdlBound = '1';
  const errEl = document.getElementById('fgErr');
  const okEl = document.getElementById('fgOk');
  const btn = document.getElementById('fgSubmit');
  form.addEventListener('submit', (ev) => {
    ev.preventDefault();
    if (errEl) errEl.textContent = '';
    if (okEl) okEl.textContent = '';
    const email = String(document.getElementById('fgEmail')?.value || '').trim();
    const mode = String(document.getElementById('fgMode')?.value || 'link');
    if (btn) btn.disabled = true;
    fetch('/api/auth/forgot-password', {
      method: 'POST',
      headers: { 'content-type': 'application/json', accept: 'application/json' },
      body: JSON.stringify({ email, mode }),
    })
      .then((r) => r.json().then((j) => ({ r, j })))
      .then(({ r, j }) => {
        if (r.status === 429) {
          let ra = Number(j.retryAfterMs);
          if (!Number.isFinite(ra) && r.headers) {
            const h = r.headers.get('retry-after');
            if (h) ra = Number(h) * 1000;
          }
          throw new Error(j.message || fmtRetry(ra));
        }
        if (!r.ok) throw new Error(j.message || j.error || 'request_failed');
        if (okEl) {
          okEl.textContent = j.message || 'If an account exists for that email, we sent instructions.';
        }
      })
      .catch((e) => {
        if (errEl) errEl.textContent = String(e?.message || 'request_failed');
      })
      .finally(() => {
        if (btn) btn.disabled = false;
      });
  });
}

document.addEventListener('pinecone:after', () => {
  queueMicrotask(bindAdminForgotFormOnce);
});

queueMicrotask(bindAdminForgotFormOnce);
